<template>
  <div class="loader-container">
    <span class="loader"></span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
};
</script>
